export class StateViewModel {
    public id: number;
    public stateView: number;
}

export class CallCenterPhoneNumberModel {
    public id: number;
    public phoneNumber: string;
}